// extracted by mini-css-extract-plugin
module.exports = {"space_right":"SubscribeForm--space_right--20KJo","form":"SubscribeForm--form--2YHtT"};